import { createTheme } from '@mui/material/styles';
import { inputsCustomizations } from './customizations/inputs';
import { dataDisplayCustomizations } from './customizations/dataDisplay';
import { feedbackCustomizations } from './customizations/feedback';
import { navigationCustomizations } from './customizations/navigation';
import { surfacesCustomizations } from './customizations/surfaces';
import { colorSchemes, typography, shadows, shape } from '../themePrimitives';

const alternativeColorSchemes = {
  light: {
    palette: {
      ...colorSchemes.light.palette,
      primary: {
        light: 'hsl(268, 88%, 80%)',
        main: 'hsl(268, 78%, 52%)',
        dark: 'hsl(268, 72%, 34%)',
        contrastText: '#ffffff',
      },
    },
  },
  dark: {
    palette: {
      ...colorSchemes.dark.palette,
      primary: {
        light: 'hsl(268, 88%, 76%)',
        main: 'hsl(268, 82%, 66%)',
        dark: 'hsl(268, 72%, 44%)',
        contrastText: 'hsl(268, 45%, 12%)',
      },
    },
  },
};

export const alternativeTheme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-mui-color-scheme',
    cssVarPrefix: 'template',
  },
  colorSchemes: alternativeColorSchemes,
  typography: {
    ...typography,
    fontFamily: '"Avenir Next", "Segoe UI", sans-serif',
  },
  shadows,
  shape: { ...shape, borderRadius: 12 },
  components: {
    ...inputsCustomizations,
    ...dataDisplayCustomizations,
    ...feedbackCustomizations,
    ...navigationCustomizations,
    ...surfacesCustomizations,
  },
});

/** @deprecated Use the descriptive `alternativeTheme` export. */
export const altThemeOne = alternativeTheme;
